import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Locale } from '@/types/api'

export type Theme = 'light' | 'dark' | 'system'

interface UiState {
  locale: Locale
  theme: Theme
  mobileMenuOpen: boolean
  setLocale: (locale: Locale) => void
  setTheme: (theme: Theme) => void
  setMobileMenuOpen: (open: boolean) => void
}

export const useUiStore = create<UiState>()(persist(
  (set) => ({
    locale: 'tr', theme: 'system', mobileMenuOpen: false,
    setLocale: (locale) => set({ locale }),
    setTheme: (theme) => set({ theme }),
    setMobileMenuOpen: (mobileMenuOpen) => set({ mobileMenuOpen }),
  }),
  { name: 'eventgallery-ui', partialize: ({ locale, theme }) => ({ locale, theme }) },
))
